enum OpportunityClosedState {
  WON = 'won',
  LOST = 'lost',
}

export default OpportunityClosedState;
